export enum ButtonType {
  submit = "submit",
  reset = "reset",
  button = "button",
}
